import qs from 'qs';
import { network } from 'services/network';

import { QueryParams } from 'api/mutations/deleteProject.mutate';

export const deleteProjectWithConstraints = ({ id }: QueryParams) => {
    const querystring = qs.stringify({ id }, { addQueryPrefix: true, skipNulls: true });
    const url = `api/bo/management/deleteProjectWithConstraints${querystring}`;
    return network.post(url).then((response) => response.data);
};
